import { render, staticRenderFns } from "./AdContentShow.vue?vue&type=template&id=2886747d&"
import script from "./AdContentShow.vue?vue&type=script&lang=js&"
export * from "./AdContentShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports